import React, { useEffect } from "react";
import { BrowserRouter as Router,  Switch } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import { Routes, THEMES } from "./constants";
import "./assets/styles/app.css";
import Layout from "./components/Layout";
import AuthProvider from "./contexts/AuthContext";
import ApiProvider from "./contexts/ApiContext";

import PublicRoute from "./routing/PublicRoute";
import PrivateRoute from "./routing/PrivateRoute";

import Login from "./pages/public/Login";
import CreateAccount from "./pages/public/CreateAccount";
import VerifyEmail from "./pages/public/VerifyEmail";
import ForgotPassword from "./pages/public/ForgotPassword";
import "react-toastify/dist/ReactToastify.min.css"
import ChangePassword from "./pages/public/ChangePassword";
import ResetPassword from "./pages/public/ResetPassword ";
import BlockchainContext from "./contexts/blockchain";
const App = React.memo(() => {
  const setTheme = (themeName: string | null) => {
    document.documentElement.className =
      themeName && THEMES.includes(themeName) ? themeName : THEMES[0];
  };


  useEffect(() => {
    setTheme("theme-dark");
  }, []);



  return (
    <Router>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <BlockchainContext>
        <ApiProvider>
          <AuthProvider>
            <Switch>
              <PublicRoute path={Routes.LOGIN} component={Login} exact />
              <PrivateRoute path={Routes.DASHBOARD} component={Layout} />
              <PublicRoute path={Routes.CREATE_ACCOUNT} component={CreateAccount} exact />
              <PublicRoute path={Routes.VERIFY_EMAIL} component={VerifyEmail} exact />
              <PublicRoute path={Routes.CHANGE_PASSWORD} component={ChangePassword} exact />
              <PublicRoute path={Routes.FORGOT_PASSWORD} component={ForgotPassword} exact />
              <PublicRoute path={Routes.RESET_PASSWORD} component={ResetPassword} exact />
            </Switch>
          </AuthProvider>
        </ApiProvider>
      </BlockchainContext>
    </Router>
  );
});

export default App;